// extracted by mini-css-extract-plugin
module.exports = {"services":"Services_services__f0Iko","card":"Services_card__wcuRS","cc":"Services_cc__2NnV3"};